var m = require('mithril');
var _ = require('lodash');
var prop = require('mithril/stream');
var flash = require('../components/flash');
var buttonElement = require('../components/button');
var header = require('../layout/components/header');
var key = require('../libs/keybindings');
var equipmentModel = require('../equipment/models/equipment');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var RequestStatus = require('../layout/enums/RequestStatus');
var heading = require('../components/heading');
var requestStatusHandler = require('../layout/components/requestStatusHandler');
var customEquipmentModel = require('../../../../models/equipment/customEquipment');
var treeEquipment = require('../locations/treeEquipment');
var editClassDatasetModal = require('./components/editClassDatasetModal');
var editClassPortModal = require('./components/editClassPortModal');
var editClassColumnModal = require('./components/editClassColumnModal');
var ontologyColumns = require('../../../../models/equipment/ontologyColumns');
var ontologyFields = require('../../../../models/equipment/ontologyFields');
var ontologyInheritance = require('./ontologyInheritance');
var ontologyPorts = require('../../../../models/equipment/ontologyPorts');
var serviceModel = require('../service/models/service');


var ontologyDetail = {};

var FIELD_NAME_LENGTH_ERROR = 'Field names must be ' + ontologyFields.MAX_FIELD_NAME_LENGTH + ' characters or fewer.';
var FIELD_VALIDATION_MESSAGES = [
  'Field name cannot be a reserved word.',
  'Field name already exists in parent class.',
  'Field names must be unique.',
  FIELD_NAME_LENGTH_ERROR,
  "Fields can't be empty."
];

function trimString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeEditableFieldRecord(field) {
  if (typeof field === 'string') {
    return {
      name: trimString(field),
      kind: '',
      defaultUnit: ''
    };
  }

  if (field && typeof field === 'object') {
    return {
      name: trimString(field.name || field.fieldName),
      kind: trimString(field.kind),
      defaultUnit: trimString(field.defaultUnit),
      definedBy: field.definedBy
    };
  }

  return {
    name: '',
    kind: '',
    defaultUnit: ''
  };
}

function normalizeEditableFieldRecords(fields) {
  return (Array.isArray(fields) ? fields : []).map(normalizeEditableFieldRecord);
}

function removeFieldValidationErrors(ctrl) {
  ctrl.errors = ctrl.errors.filter(function (message) {
    return FIELD_VALIDATION_MESSAGES.indexOf(message) === -1;
  });
}

function addFieldValidationError(ctrl, message) {
  if (ctrl.errors.indexOf(message) === -1) {
    ctrl.errors.push(message);
  }
}

function refreshFieldValidationErrors(ctrl) {
  removeFieldValidationErrors(ctrl);
  var parentFieldNames = new Set((ctrl.parentFieldsArray || []).map(function (field) {
    return trimString(field && field.name).toLowerCase();
  }).filter(Boolean));
  var reservedFieldNames = new Set(ctrl.reservedFieldNames.map(function (fieldName) {
    return String(fieldName || '').toLowerCase();
  }));
  var hiddenReservedFieldNames = new Set(ctrl.hidenReservedFieldNames.map(function (fieldName) {
    return String(fieldName || '').toLowerCase();
  }));
  var seenFieldNames = new Set();

  normalizeEditableFieldRecords(ctrl.equipmentClass().data.fields).forEach(function (field) {
    var fieldName = trimString(field.name);
    if (!fieldName) {
      addFieldValidationError(ctrl, "Fields can't be empty.");
      return;
    }

    var lengthError = ontologyFields.getFieldNameLengthError(fieldName);
    if (lengthError) {
      addFieldValidationError(ctrl, lengthError);
    }

    var lowerCaseFieldName = fieldName.toLowerCase();
    if (reservedFieldNames.has(lowerCaseFieldName) || hiddenReservedFieldNames.has(lowerCaseFieldName)) {
      addFieldValidationError(ctrl, 'Field name cannot be a reserved word.');
    }
    if (parentFieldNames.has(lowerCaseFieldName)) {
      addFieldValidationError(ctrl, 'Field name already exists in parent class.');
    }
    if (seenFieldNames.has(lowerCaseFieldName)) {
      addFieldValidationError(ctrl, 'Field names must be unique.');
    }
    seenFieldNames.add(lowerCaseFieldName);
  });
}

function normalizeFieldNameInput(value) {
  return _.camelCase(String(value || ''));
}

function buildColumnMetadataText(columnRecord) {
  var metadata = [];
  if (trimString(columnRecord && columnRecord.kind)) {
    metadata.push('Kind: ' + trimString(columnRecord.kind));
  }
  if (trimString(columnRecord && columnRecord.defaultUnit)) {
    metadata.push('Default: ' + trimString(columnRecord.defaultUnit));
  }
  return metadata.join('  ');
}

ontologyDetail.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Ontology');
  document.title = 'nimrod | Ontology';
  ctrl.errors = [];
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.saveRequestStatus = prop(RequestStatus.SUCCESS);
  ctrl.ontologyRecord = prop();
  ctrl.instanceCount = null;
  ctrl.instanceCountError = null;
  ctrl.classNotFound = false;
  ctrl.reservedFieldNames = Object.entries(customEquipmentModel.fields)
    .filter(([key, value]) => !value.hidden)
    .map(([key]) => key);
  ctrl.hidenReservedFieldNames = Object.entries(customEquipmentModel.fields)
    .filter(([key, value]) => value.hidden)
    .map(([key]) => key);

  ctrl.reservedGroupNames = ['Default'];
  ctrl.availableFieldKinds = [];
  ctrl.availableUnits = [];

  var params = m.parseQueryString(m.route.get().split('?')[1]);
  ctrl.templatePathLookupVersion = 0;
  ctrl.locationClassNames = ['Site', 'Building', 'Level', 'Room'];

  ctrl.isLocationClass = function (className) {
    return ctrl.locationClassNames.indexOf(className) > -1;
  };

  ctrl.getTemplatePathNodeLabel = function (node) {
    if (!node) return '';
    if (node.name === 'root') return 'Home';
    var nodeName = node.name || node['@class'] || '';
    if (!nodeName) return '';
    if (node['@class'] === 'Room') {
      var roomNumber = node.roomNumber ? String(node.roomNumber).trim() : '';
      return roomNumber ? `${nodeName} ${roomNumber}` : nodeName;
    }
    return nodeName;
  };

  ctrl.getTemplatePathNodeHref = function (node) {
    if (!node) return null;
    if (node.name === 'root') return '/location';
    if (!node['@rid']) return null;
    if (ctrl.isLocationClass(node['@class'])) {
      return `/location/${node['@rid'].slice(1)}`;
    }
    if (!node['@class']) return null;
    return `/equipment/${node['@class'].toLowerCase()}/${node['@rid'].slice(1)}`;
  };

  ctrl.fetchTemplatePathByRid = async function (templateRid) {
    var normalizedRid = normalizeTemplateEquipmentRid(templateRid);
    if (!normalizedRid) {
      return { pathLabel: '', pathNodes: [] };
    }
    try {
      var equipmentPathData = await loaders.requestWithLoader({
        loader: 'background',
        url: '/api/v1/equipment/' + encodeURIComponent(normalizedRid.slice(1)) + '/path',
        method: 'GET',
        background: true
      });
      var pathLabel = equipmentPathData && typeof equipmentPathData.pathLabel === 'string'
        ? equipmentPathData.pathLabel.trim()
        : '';
      var pathNodes = equipmentPathData && Array.isArray(equipmentPathData.path)
        ? equipmentPathData.path.slice().reverse()
        : [];
      return { pathLabel, pathNodes };
    } catch (error) {
      console.error('Unable to resolve template path for rid', normalizedRid, error);
      return { pathLabel: '', pathNodes: [] };
    }
  };

  ctrl.loadTemplatePathForIndex = async function (templateIdx, options) {
    var opts = options || {};
    var equipmentClassRecord = ctrl.equipmentClass && ctrl.equipmentClass();
    if (!equipmentClassRecord || !equipmentClassRecord.data || !Array.isArray(equipmentClassRecord.data.templates)) return;
    var templateRecord = equipmentClassRecord.data.templates[templateIdx];
    if (!templateRecord) return;
    if (opts.onlyIfMissing && templateRecord.path) return;

    var normalizedRid = normalizeTemplateEquipmentRid(templateRecord.equipmentRid);
    if (!normalizedRid) {
      templateRecord.path = '';
      templateRecord.pathNodes = [];
      return;
    }

    var lookupVersion = opts.lookupVersion || (++ctrl.templatePathLookupVersion);
    var resolvedPathData = await ctrl.fetchTemplatePathByRid(normalizedRid);
    var latestEquipmentClassRecord = ctrl.equipmentClass && ctrl.equipmentClass();
    if (!latestEquipmentClassRecord || !latestEquipmentClassRecord.data || !Array.isArray(latestEquipmentClassRecord.data.templates)) return;
    var latestTemplateRecord = latestEquipmentClassRecord.data.templates[templateIdx];
    if (!latestTemplateRecord) return;
    if (lookupVersion !== ctrl.templatePathLookupVersion) return;
    if (normalizeTemplateEquipmentRid(latestTemplateRecord.equipmentRid) !== normalizedRid) return;

    latestTemplateRecord.path = resolvedPathData.pathLabel || '';
    latestTemplateRecord.pathNodes = Array.isArray(resolvedPathData.pathNodes) ? resolvedPathData.pathNodes : [];
    m.redraw();
  };

  ctrl.populateTemplatePaths = function () {
    var equipmentClassRecord = ctrl.equipmentClass && ctrl.equipmentClass();
    if (!equipmentClassRecord || !equipmentClassRecord.data || !Array.isArray(equipmentClassRecord.data.templates)) return;
    var lookupVersion = ++ctrl.templatePathLookupVersion;
    equipmentClassRecord.data.templates.forEach(function (_templateRecord, idx) {
      ctrl.loadTemplatePathForIndex(idx, { lookupVersion: lookupVersion });
    });
  };

  ctrl.loadFieldMetadataOptions = async function () {
    try {
      var responses = await Promise.all([
        loaders.requestWithLoader({
          loader: 'background',
          url: '/api/v1/unit/dimensions',
          method: 'GET',
          background: true
        }),
        loaders.requestWithLoader({
          loader: 'background',
          url: '/api/v1/unit',
          method: 'GET',
          background: true
        })
      ]);
      ctrl.availableFieldKinds = ontologyFields.listKnownFieldKinds(responses[0]);
      ctrl.availableUnits = Array.isArray(responses[1]) ? responses[1] : [];
    } catch (error) {
      console.error('Unable to load ontology field metadata options', error);
      ctrl.availableFieldKinds = ontologyFields.listKnownFieldKinds([]);
      ctrl.availableUnits = [];
    }
  };

  ctrl.openTemplateEquipmentPicker = function (templateIdx) {
    if (!ctrl.equipmentClass() || !ctrl.equipmentClass().data || !Array.isArray(ctrl.equipmentClass().data.templates)) return;
    const selectedEquipment = prop();

    modal.vm.title('Select Template Equipment');
    modal.vm.body = function () {
      return m('form', { role: 'form' }, [
        m(treeEquipment, {
          selectedNode: selectedEquipment,
          onSelect: function (selectedNode) {
            if (!selectedNode || !selectedNode['@rid']) return selectedNode;
            ctrl.equipmentClass().data.templates[templateIdx].equipmentRid = selectedNode['@rid'];
            ctrl.equipmentClass().data.templates[templateIdx].path = '';
            ctrl.loadTemplatePathForIndex(templateIdx);
            modal.vm.close();
            m.redraw();
            return selectedNode;
          }
        })
      ]);
    };
    modal.vm.buttons([
      {
        label: 'Close',
        class: 'btn-cancel',
        func: modal.vm.close
      }
    ]);
    modal.vm.open({ extrawidth: true });
  };

  var showRenameWarning = function (oldClassName, newClassName, confirmRename) {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', confirmRename);

    modal.vm.title(`Rename ${oldClassName} to ${newClassName}?`);
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Warning, changing a class name can impact dashboards and elements configured for that class, plugins set up for the previous class name will no longer be matched. Manual updates may be necessary following this operation.')
      ]);
    };

    modal.vm.buttons([
      {
        label: 'Cancel',
        class: 'dib mr2',
        func: function () {
          key.deleteScope('modal');
          modal.vm.close();
        }
      },
      {
        label: 'Rename',
        class: 'dib red',
        func: confirmRename
      }
    ]);

    modal.vm.open();
  };


  ctrl.submit = async function (skipRenameWarning) {
    ctrl.saveRequestStatus(RequestStatus.PENDING);
    ctrl.temporalStateEquipmentClassDatasets = [...ctrl.equipmentClass().data.datasets];
    
    ctrl.errors = [];
    ctrl.classSaved = false;
    try {
      if (ctrl.classNotFound) {
        throw new Error('This class is not available in the Equipment ontology.');
      }
      if (!ctrl.equipmentClass().name) {
        throw new Error('Name is required');
      }
      var currentRouteClass = m.route.param('class');
      var routeClass = currentRouteClass && currentRouteClass.trim() ? currentRouteClass.trim() : '';
      var isNewClass = routeClass === 'new';
      var className = (ctrl.equipmentClass().name || '').trim();
      if (!/^[A-Za-z0-9_]+$/.test(className)) {
        throw new Error('Name must use letters, numbers, or underscores only');
      }
      var shouldRename = !isNewClass && routeClass && className && routeClass !== className;
      var isBaseClass = routeClass && ['Equipment', 'Zone'].includes(routeClass);

      if (shouldRename && isBaseClass) {
        throw new Error('Cannot rename base class');
      }
      if (shouldRename && !skipRenameWarning) {
        showRenameWarning(routeClass, className, function () {
          modal.vm.close();
          ctrl.submit(true);
        });
        return;
      }

      ctrl.equipmentClass().data.templates = normalizeTemplates(ctrl.equipmentClass().data.templates);
      ctrl.equipmentClass().data.fields = normalizeEditableFieldRecords(ctrl.equipmentClass().data.fields)
        .map(function (fieldRecord) {
          return {
            name: normalizeFieldNameInput(fieldRecord.name),
            kind: trimString(fieldRecord.kind),
            defaultUnit: trimString(fieldRecord.defaultUnit)
          };
        });
      await serviceModel.getClassTree().catch(function () {
        return null;
      });
      ctrl.equipmentClass().data.ports = ontologyPorts.normalizePortDefinitions(ctrl.equipmentClass().data.ports, {
        fallbackServiceClass: getDefaultServiceClass()
      });
      addValidationErrors(ctrl.errors, ontologyPorts.validatePortDefinitions(ctrl.equipmentClass().data.ports));
      addValidationErrors(ctrl.errors, ontologyColumns.validateDatasetDefinitions(
        (ctrl.parentDatasetsArray || []).concat(ctrl.equipmentClass().data.datasets || [])
      ));
      refreshFieldValidationErrors(ctrl);

      let uniquePortNames = arePortNamesUnique([...ctrl.parentPortsArray, ...ctrl.equipmentClass().data.ports], ctrl.errors);
      let validProperties = validateEmptyProperties(ctrl.equipmentClass(), ctrl.errors);
      
      if (!uniquePortNames || !validProperties || ctrl.errors.length > 0) {
        throw new Error('Invalid form data');
      }
      ctrl.equipmentClass().data.datasets = [
        ...ctrl.parentDatasetsArray
          .map(item => ({
            ...item,
            definedBy: undefined,
            columns: ontologyColumns.normalizeColumnDefinitions((item.columns || []).filter(column => column.definedBy === undefined)),
          }))
          .filter(item => item.columns.length > 0),
        ...ctrl.equipmentClass().data.datasets
      
      ].map(item => {
        return Object.assign({}, item, {
          definedBy: undefined,
          columns: ontologyColumns.normalizeColumnDefinitions((item.columns || []).filter(column => {
            return trimString(column && column.name) !== '' && column.definedBy == undefined;
          }))
        });
      });
      ctrl.equipmentClass().data.datasets = ontologyColumns.normalizeDatasetDefinitions(ctrl.equipmentClass().data.datasets);

      if (shouldRename) {
        await equipmentModel.renameClass(routeClass, className);
      }
      
  
      delete ctrl.equipmentClass().allChildrenColumns;
      delete ctrl.equipmentClass().children;
      ctrl.equipmentClass().data.fields = ontologyFields.normalizeFieldDefinitions(ctrl.equipmentClass().data.fields);
  
      let response = await equipmentModel.saveChildrenClassData(convertToFormData(ctrl.equipmentClass()));

      if (response.errors) {
        ctrl.errors = response.errors;
      } else {
        ctrl.classSaved = true;
        ctrl.errors = [];
      }
      if (isNewClass) {
        await ensureClassAvailable(className);
        m.route.set(`/ontology/${ctrl.equipmentClass().name}`, null, { replace: true });
        ctrl.saveRequestStatus(RequestStatus.SUCCESS);
        return;
      } else if (shouldRename) {
        m.route.set('/ontology', null, { replace: true });
        ctrl.saveRequestStatus(RequestStatus.SUCCESS);
        return;
      }
      await ctrl.init();
      ctrl.saveRequestStatus(RequestStatus.SUCCESS);
    } catch (error) {
      
      if (ctrl.errors.length === 0 && error) {
        if (error.error) {
          ctrl.errors.push(error.error);
        } else if (error.message) {
          ctrl.errors.push(error.message);
        } else {
          ctrl.errors.push(error.toString());
        }
      }
      throw new Error(ctrl.errors[0] || 'Unable to save class');
    }
   
  };

  ctrl.init = async function () {
    ctrl.equipmentClassName = m.route.param('class')
    ctrl.equipmentClass = prop(undefined);
    ctrl.instanceCount = null;
    ctrl.instanceCountError = null;
    ctrl.classNotFound = false;
    await Promise.all([
      equipmentModel.requestClassTree(),
      ctrl.loadFieldMetadataOptions()
    ]);

    ctrl.parentDatasetsArray = [];
    ctrl.parentFieldsArray = [];
    ctrl.parentPortsArray = [];

    var inheretedClassData;
    var selectedParentClassRecord = null;
    if (m.route.param('class') && (m.route.param('class') !== 'new')) {
      inheretedClassData = equipmentModel.getInheretedClassData(m.route.param('class'));      
      console.log(inheretedClassData);
    } else {
      inheretedClassData = equipmentModel.getInheretedClassData(params.parent);
      selectedParentClassRecord = JSON.parse(JSON.stringify(inheretedClassData.foundEquipmentClass || {}));
      inheretedClassData.foundEquipmentClass = { data: {} };
    }
    ctrl.equipmentClass(inheretedClassData.foundEquipmentClass);
    ctrl.parentDatasetsArray = inheretedClassData.parentDatasetsArray;
    ctrl.parentFieldsArray = inheretedClassData.parentFieldsArray;
    ctrl.parentPortsArray = inheretedClassData.parentPortsArray;
    if (selectedParentClassRecord && selectedParentClassRecord.name) {
      ontologyInheritance.includeClassDataAsInheritedParent(
        selectedParentClassRecord,
        ctrl.parentDatasetsArray,
        ctrl.parentFieldsArray,
        ctrl.parentPortsArray
      );
    }
    if (m.route.param('class') && (m.route.param('class') !== 'new') && (!ctrl.equipmentClass() || !ctrl.equipmentClass().name)) {
      ctrl.classNotFound = true;
      ctrl.equipmentClass({name: m.route.param('class')});
      return;
    }
    
    if (!ctrl.equipmentClass()) return
    if (!ctrl.equipmentClass().data.svg) ctrl.equipmentClass().data.svg = '';
    if (!ctrl.equipmentClass().data.shortname) ctrl.equipmentClass().data.shortname = '';
    ctrl.equipmentClass().data.fields = normalizeEditableFieldRecords(ctrl.equipmentClass().data.fields);
    if (!ctrl.equipmentClass().data.ports) ctrl.equipmentClass().data.ports = [];
    ctrl.equipmentClass().data.templates = normalizeTemplates(ctrl.equipmentClass().data.templates);
    ctrl.populateTemplatePaths();
    if (!ctrl.equipmentClass().data.datasets || !Array.isArray(ctrl.equipmentClass().data.datasets)) {
      if (ontologyInheritance.hasDatasetNamed(ctrl.parentDatasetsArray, 'Default')) {
        ctrl.equipmentClass().data.datasets = [];
      }  else {
        ctrl.equipmentClass().data.datasets = [
          {
            name: 'Default',
            columns: [],
            visible: true,
            id: 0
          }
        ];
      }
    } else {
      if (!ontologyInheritance.hasDatasetNamed(ctrl.parentDatasetsArray, 'Default') && !ontologyInheritance.hasDatasetNamed(ctrl.equipmentClass().data.datasets, 'Default')) {
        ctrl.equipmentClass().data.datasets.push({
          name: 'Default',
          columns: [],
          id: 0,
          visible: true
        });
      }
      ctrl.parentDatasetsArray.forEach(dataset => {

        dataset.columns.forEach(column => {
          column.notEditable = true;
        });

        const commonDatasetIndex = ctrl.equipmentClass().data.datasets.findIndex(group => group.name === dataset.name);
        
        if (commonDatasetIndex !== -1 && dataset.columns && Array.isArray(dataset.columns)) {
          const commonDataset = ctrl.equipmentClass().data.datasets[commonDatasetIndex];

          dataset.columns = [
            ...dataset.columns,
            ...commonDataset.columns || [] 
          ];
          ctrl.equipmentClass().data.datasets.splice(commonDatasetIndex, 1);
        }
      });

      ctrl.equipmentClass().data.datasets.sort((a, b) => a.id - b.id)
    }

    const lowerCaseHiddenReserved = new Set(
      ctrl.hidenReservedFieldNames
        .filter(field => typeof field === 'string')
        .map(field => field.toLowerCase())
    );

    const lowerCaseReservedFields = new Set(
      ctrl.reservedFieldNames
        .filter(field => typeof field === 'string')
        .map(field => field.toLowerCase())
    );
    ctrl.equipmentClass().data.fields = ctrl.equipmentClass().data.fields.filter(field => {
      const fieldName = trimString(field && field.name);
      if (!fieldName) {
        return false;
      }
      const lowerCaseField = fieldName.toLowerCase();
      return !lowerCaseHiddenReserved.has(lowerCaseField) &&
        !lowerCaseReservedFields.has(lowerCaseField);
    });
    refreshFieldValidationErrors(ctrl);


    if (params.parent) {
      ctrl.equipmentClass().parent = params.parent;
    }

    if (m.route.param('class') && m.route.param('class') !== 'new' && !ctrl.classNotFound) {
      loaders.requestWithLoader({
        loader: 'background',
        url: `/api/v1/ontology/class/${encodeURIComponent(m.route.param('class'))}/count?type=equipment`,
        method: 'GET',
        background: true
      })
      .then(response => {
        ctrl.instanceCount = typeof response.count === 'number' ? response.count : null;
        ctrl.instanceCountError = null;
        ctrl.classNotFound = false;
        m.redraw();
      })
      .catch(error => {
        console.error('Error fetching class count:', error);
        ctrl.instanceCount = null;
        ctrl.instanceCountError = error;
        m.redraw();
      });
    }
  }
  ctrl.init()
    .then(() => {
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    })

  key.setScope('profile');

};


ontologyDetail.onremove = function () {
  key.deleteScope('profile');
  key.setScope('home');
}

ontologyDetail.onupdate = function () {
  var ctrl = this;
  if(ctrl.equipmentClassName != m.route.param('class')) {
    ctrl.init()
    .then(() => {
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    })
  }
}
    

ontologyDetail.view = function (vnode) {
  var ctrl = this;
  ctrl.portCenterSelected = prop(false);
  (ctrl.parentPortsArray || []).forEach(port => {
    if (port.position == 'center') {
      ctrl.portCenterSelected(true);
    };
  });
  (ctrl.equipmentClass()?.data?.ports || []).forEach(port => {
    if (port.position == 'center') {
      ctrl.portCenterSelected(true);
    };
  });

  if (ctrl.requestStatus() !== RequestStatus.SUCCESS) {
    return m(requestStatusHandler, { requestStatus: ctrl.requestStatus });
  }

  if (ctrl.classNotFound) {
    return m('div.container', [
      m(flash, {
        items: ['This class is not available in the Equipment ontology.'],
        bg: 'bg-red'
      })
    ]);
  }
  
  if(ctrl.saveRequestStatus() !== RequestStatus.SUCCESS) {
    ctrl.equipmentClass().data.datasets = ctrl.temporalStateEquipmentClassDatasets;
  }
  var currentRouteClass = m.route.param('class');
  var isBaseClass = currentRouteClass && currentRouteClass !== 'new' && ['Equipment', 'Zone'].includes(currentRouteClass);
  
  return m('div.container', [
    m(heading, {
      label: m.route.param('class') === 'new' ? 
        [
          m(m.route.Link, {href: `/ontology/${ctrl.equipmentClass().parent}`}, ctrl.equipmentClass().parent),
          ` / New Equipment Class`
        ] 
      : 
        `Edit ${ctrl.equipmentClass().name}`,
      class: 'f-subheadline mb3 pb1'
    }),
    m('div.f6.gray.mb2', {
      class: ctrl.instanceCountError ? 'dark-red' : 'gray'
    }, m.route.param('class') === 'new'
      ? ''
      : (typeof ctrl.instanceCount === 'number'
        ? `Instances: ${ctrl.instanceCount}`
        : 'Instances: unavailable'
      )
    ),
    m('div', {
      style: {
        position: 'sticky',
        top: '0',
      }
    }, [
      ctrl.errors.length ?
        m(flash, {
          items: ctrl.errors,
          bg: 'bg-red'
        })
        :
        '',
      ctrl.classSaved ?
        m(flash, {
          items: [`Class '${ctrl.equipmentClass().name}' saved successfully.`],
          bg: 'bg-green'
        })
        :
        ''
    ]),
    m('div.flex.flex-wrap', [
      m('div.w-100', [
        m('form', { role: 'form' }, [
          m('div', { class: 'form-group' }, [
            m('div.f3.pv2', 'Name'),
            m('input.form-control', {
              id: 'name-input',
              type: 'text',
              oninput: function (ev) { ctrl.equipmentClass().name = ev.target.value.replace(/\s+/g, ''); },
              value: ctrl.equipmentClass().name,
              disabled: isBaseClass,
              placeholder: 'Name'
            })
          ])
        ]),
        m('div', { class: 'form-group' }, [
          m('div.f2.pv2', 'Fields'),
          m('div.flex.items-center.mv1', [
            m('div.pr2.f6.b.near-white-50.ttc', { style: { flex: '0 0 30%', maxWidth: '30%' } }, 'Name'),
            m('div.pr2.f6.b.near-white-50.ttc', { style: { flex: '0 0 25%', maxWidth: '25%' } }, 'Kind'),
            m('div.pr2.f6.b.near-white-50.ttc', { style: { flex: '0 0 25%', maxWidth: '25%' } }, 'Default Unit'),
            m('div.f6.b.near-white-50.ttc', { style: { flex: '0 0 20%', maxWidth: '20%' } }, 'Defined By / Actions')
          ]),
          ctrl.parentFieldsArray.map(fieldObj => {
            return m('div.flex.items-center', [
              m('div.pr2', { style: { flex: '0 0 30%', maxWidth: '30%' } }, [
                m('input.form-control.mv1', {
                  type: 'text',
                  value: fieldObj.name,
                  disabled: 'disabled'
                })
              ]),
              m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
                m('input.form-control.mv1', {
                  type: 'text',
                  value: fieldObj.kind || '',
                  disabled: 'disabled'
                })
              ]),
              m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
                m('input.form-control.mv1', {
                  type: 'text',
                  value: fieldObj.defaultUnit || '',
                  disabled: 'disabled'
                })
              ]),
              m('div.pv2', { style: { flex: '0 0 20%', maxWidth: '20%' } }, [
                m('div.truncate.ba.bw1.pa2',[
                  m(m.route.Link, {
                    href: `/ontology/${fieldObj.definedBy}`,
                    class: 'pl2'
                  }, fieldObj.definedBy)
                ])
              ])
            ])
          }),
          (ctrl.equipmentClass()?.data?.fields || []).map((fieldRecord, idx) => {
            var unitSuggestions = ontologyFields.getUnitsForKind(fieldRecord.kind, ctrl.availableUnits)
              .reduce(function (names, unitRecord) {
                [unitRecord && unitRecord.name].concat(Array.isArray(unitRecord && unitRecord.aliases) ? unitRecord.aliases : [])
                  .forEach(function (token) {
                    var trimmed = trimString(token);
                    if (!trimmed || names.indexOf(trimmed) >= 0) return;
                    names.push(trimmed);
                  });
                return names;
              }, []);
            var unitListId = `ontology-field-unit-${idx}`;
            return m('div.flex.items-center', [
              m('div.pr2', { style: { flex: '0 0 30%', maxWidth: '30%' } }, [
                m('input.form-control.mv1.w-100', {
                  type: 'text',
                  oninput: function (ev) {
                    ctrl.equipmentClass().data.fields[idx].name = ev.target.value;
                  },
                  onfocusout: function (ev) {
                    ctrl.equipmentClass().data.fields[idx].name = normalizeFieldNameInput(ev.target.value);
                    refreshFieldValidationErrors(ctrl);
                  },
                  value: fieldRecord.name || '',
                  placeholder: 'Field name'
                }),
              ]),
              m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
                m('input.form-control.mv1.w-100', {
                  type: 'text',
                  list: 'ontology-field-kind-options',
                  oninput: function (ev) {
                    ctrl.equipmentClass().data.fields[idx].kind = ev.target.value;
                  },
                  value: fieldRecord.kind || '',
                  placeholder: 'Kind'
                })
              ]),
              m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
                m('input.form-control.mv1.w-100', {
                  type: 'text',
                  list: unitListId,
                  oninput: function (ev) {
                    ctrl.equipmentClass().data.fields[idx].defaultUnit = ev.target.value;
                  },
                  value: fieldRecord.defaultUnit || '',
                  placeholder: 'Default unit'
                }),
                m('datalist', { id: unitListId }, unitSuggestions.map(function (unitName) {
                  return m('option', { value: unitName });
                }))
              ]),
              m('div.pv2', { style: { flex: '0 0 20%', maxWidth: '20%' } }, [
                m(buttonElement, {
                  class: 'w-100 fr',
                  label: m('i.f4.ion-ios-trash.red'),
                  func: function () {
                    ctrl.equipmentClass().data.fields.splice(idx, 1);
                    refreshFieldValidationErrors(ctrl);
                  }
                })
              ])
            ])
          }),
          m('datalist', { id: 'ontology-field-kind-options' }, (ctrl.availableFieldKinds || []).map(function (kind) {
            return m('option', { value: kind });
          })),
          m('div.flex.items-center', [
            m('div.pr2', { style: { flex: '0 0 30%', maxWidth: '30%' } }, [
              m('input.form-control.mv1.w-100', {
                type: 'text',
                style: { visibility: 'hidden' }
              })
            ]),
            m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
              m('input.form-control.mv1.w-100', {
                type: 'text',
                style: { visibility: 'hidden' }
              })
            ]),
            m('div.pr2', { style: { flex: '0 0 25%', maxWidth: '25%' } }, [
              m('input.form-control.mv1.w-100', {
                type: 'text',
                style: { visibility: 'hidden' }
              })
            ]),
            m('div.pv2', { style: { flex: '0 0 20%', maxWidth: '20%' } }, [
              m(buttonElement, {
                class: 'w-100 fr',
                label: m('i.ion-plus.blue'),
                func: function () {
                  ctrl.equipmentClass().data.fields.push({
                    name: '',
                    kind: '',
                    defaultUnit: ''
                  })
                }
              })
            ])
          ])
        ])
      ]),
    ]),
    m('div.w-100', [
      m('div.f2.pv2', 'Datasets'),
      m('div.w-100.pt2.pb3', [
        m('ul.ph0.mv0', [
          ctrl.parentDatasetsArray.map((dataset, idx) => {
            return datasetTemplate(dataset, idx, ctrl.parentDatasetsArray, ctrl)
          }),
          ctrl.equipmentClass().data.datasets.map((group, idx) => {
            return datasetTemplate(group, idx, ctrl.equipmentClass().data.datasets, ctrl)
          }),
        ]),
        m('div.flex.mv2', [
          m('div.flex-auto', [
            m(buttonElement, {
              class: 'blue w-100',
              label: [
                m('i.ion-plus.blue.mh1'),
                'Add Dataset'
              ],
              func: function () {
                let newDatasetRecord = {
                  name: '',
                  type: 'list',
                  showInSummary: false,
                  hideInDiagram: false,
                  id: ontologyColumns.nextDatasetId(ctrl.equipmentClass().data.datasets)
                }; 
                let submitCallback = async function(newDatasetRecord) {
                  ctrl.equipmentClass().data.datasets.push(newDatasetRecord);
                  await ctrl.submit();
                }
                editClassDatasetModal.editDialogue(newDatasetRecord, {submitCallback});
              }
            })
          ]),
          m('div.w-0.w4-ns.w5-l.ml2-m.ml2-l')
        ]),
      ])
    ]),
    m('div.w-100', [
      m('div.f2.pv2', 'Ports'),
      m('div.w-100.pt2.pb3', [
        ctrl.parentPortsArray.map((port, idx) => {
          return portTemplate(port, idx, ctrl.parentPortsArray, ctrl)
        }),
        ctrl.equipmentClass().data.ports.map((port, idx) => {
          return portTemplate(port, idx, ctrl.equipmentClass().data.ports, ctrl)
        }),
        m('div.flex.mv2', [
          m(buttonElement, {
            class: 'blue flex-auto',
            label: [
              m('i.ion-plus.blue.mh1'),
              'Add Port'
            ],
            func: function () {
              let newPortRecord = ontologyPorts.buildPortDefinition({
                name: '',
                id: ontologyPorts.nextPortId(ctrl.equipmentClass().data.ports)
              }, {
                fallbackServiceClass: getDefaultServiceClass()
              });

              let submitCallback = async function (newPortRecord) {
                ctrl.equipmentClass().data.ports.push(newPortRecord);
                await ctrl.submit();
              }
              editClassPortModal.editDialogue(newPortRecord, ctrl.portCenterSelected, {submitCallback});
            }
          }),
          m('div.w-0.w4-ns.w5-l.ml2-m.ml2-l')
        ])
      ])
    ]),
    m('div.w-100', [
      m('div.f3.pv2', 'Diagram SVG'),
      m('textarea.h5.mt2', {
        style: {
          resize: 'none'
        },
        rows: 5,
        'box-sizing': 'border-box',
        value: ctrl.equipmentClass().data.svg,
        oninput: function (ev) { ctrl.equipmentClass().data.svg = ev.target.value },
        placeholder: "Add SVG data here...",
      })
    ]),
    m('div.w-100', [
      m('div.f2.pv2', 'Templates'),
      m('div.flex.items-center.mv1', [
        m('div.pr2.f6.b.near-white-50.ttc', { style: { flex: '0 0 20%', maxWidth: '20%' } }, 'Name'),
        m('div.pr2.f6.b.near-white-50.ttc', { style: { flex: '0 0 15%', maxWidth: '15%' } }, 'Template ID'),
        m('div.f6.b.near-white-50.ttc', { style: { flex: '0 0 65%', maxWidth: '65%' } }, [
          m('div.flex.items-center', [
            m('div.flex-auto', 'Path'),
            m('div.tc', { style: { width: '90px', flex: '0 0 90px' } }, 'Actions')
          ])
        ]),
      ]),
      (ctrl.equipmentClass()?.data?.templates || []).map((templateRecord, idx) => {
        return m('div.flex.items-center.mv1', [
          m('div.pr2', { style: { flex: '0 0 20%', maxWidth: '20%' } }, [
            m('input.form-control.w-100', {
              type: 'text',
              value: templateRecord.name || '',
              oninput: function (ev) {
                ctrl.equipmentClass().data.templates[idx].name = ev.target.value;
              },
              placeholder: 'Template name'
            })
          ]),
          m('div.pr2', { style: { flex: '0 0 15%', maxWidth: '15%' } }, [
            m('input.form-control.w-100', {
              type: 'text',
              value: templateRecord.equipmentRid || '',
              oninput: function (ev) {
                ctrl.equipmentClass().data.templates[idx].equipmentRid = ev.target.value;
                ctrl.equipmentClass().data.templates[idx].path = '';
                ctrl.equipmentClass().data.templates[idx].pathNodes = [];
              },
              onblur: function () {
                ctrl.loadTemplatePathForIndex(idx);
              },
              placeholder: 'Equipment @rid (e.g. #12:0)'
            })
          ]),
          m('div', { style: { flex: '0 0 65%', maxWidth: '65%' } }, [
            m('div.flex.items-center', [
              m('div.near-white.flex-auto.flex.items-center', {
                style: {
                  minHeight: '38px',
                  lineHeight: '1.2'
                },
                title: templateRecord.path || ''
              }, Array.isArray(templateRecord.pathNodes) && templateRecord.pathNodes.length
                ? m('div.flex.flex-wrap.items-center.w-100', templateRecord.pathNodes
                  .map(function (node) {
                    return {
                      node: node,
                      label: ctrl.getTemplatePathNodeLabel(node)
                    };
                  })
                  .filter(function (entry) {
                    return entry.label;
                  })
                  .map(function (entry, nodeIdx, entries) {
                    var href = ctrl.getTemplatePathNodeHref(entry.node);
                    return m('span', [
                      href
                        ? m(m.route.Link, { href: href, class: 'blue' }, entry.label)
                        : m('span', entry.label),
                      nodeIdx < entries.length - 1 ? m('span.white.mh1', '/') : ''
                    ]);
                  }))
                : m('span', templateRecord.path || 'No path')),
              m('div.pv2.flex.ml2', { style: { width: '90px', flex: '0 0 90px' } }, [
                m(buttonElement, {
                  class: 'w-50 mr1',
                  label: m('i.f4.ion-search.blue'),
                  func: function () {
                    ctrl.openTemplateEquipmentPicker(idx);
                  }
                }),
                m(buttonElement, {
                  class: 'w-50',
                  label: m('i.f4.ion-ios-trash.red'),
                  func: function () {
                    ctrl.equipmentClass().data.templates.splice(idx, 1);
                  }
                }),
              ])
            ])
          ])
        ])
      }),
      m('div.flex.items-center', [
        m('div.flex-auto', [
          m('input.form-control.mv1.w-100', {
            type: 'text',
            style: { "visibility": 'hidden' }
          })
        ]),
        m('div.pv2.ml2.w-third.w4-ns.w5-l', [
          m(buttonElement, {
            class: 'w-100 fr',
            label: m('i.ion-plus.blue'),
            func: function () {
              ctrl.equipmentClass().data.templates.push({
                name: '',
                equipmentRid: '',
                path: '',
                pathNodes: []
              });
            }
          })
        ])
      ])
    ]),
    m(buttonElement, {
      label: 'Save',
      class: 'mt2 mb3',
      func: ctrl.submit
    })
  ])
};

function portTemplate(port, idx, portArray, ctrl) {
  return m('div.flex.items-center.mb1', [
    m('div.ba.pa2.bw1.flex-auto', [
      port.name ?
        m('div', port.name)
      : 
        m('div', {style: { 'visibility': 'hidden'}}, 'Placeholder')
    ]),
    m(`div.pv2.ml2.w-third.w4-ns.w5-l${port.definedBy ? '' : '.flex'}`, [
      port.definedBy ? 
          m('div.truncate.ba.bw1.pa2',[
            m(m.route.Link, { 
              href: `/ontology/${port.definedBy}`, 
              class: 'pl2'
            }, port.definedBy)
          ])
        :
          [
            m(buttonElement, {
              class: 'w-50 mr1',
              label: m('i.f4.ion-ios-compose-outline.blue'),
              func: editClassPortModal.editDialogue.bind(editClassPortModal, port, ctrl.portCenterSelected, {submitCallback: ctrl.submit})
            }),
            m(buttonElement, {
              class: 'w-50',
              label: m('i.f4.ion-ios-trash.red'),
              func: function () {
                portArray.splice(idx, 1)
              }
            })
          ]
    ])
  ])
}

function datasetTemplate(dataset, idx, datasetDarray, ctrl) {
  return m('div.flex.items-start', [
    m('li.ba.pa2.bw1.flex-auto', {
      style: { 'list-style': 'none' },
      class: 'mv2',
      onclick: function (e) {
        e.stopPropagation();
        if (e.srcElement.nodeName === 'I') {
          if (e.srcElement.classList.contains('ion-arrow-right-b')) {
            e.srcElement.classList.remove('ion-arrow-right-b');
            e.srcElement.classList.add('ion-arrow-down-b');
            e.srcElement.parentElement.parentElement.childNodes.forEach(element => {
              if(element && element.classList) element.classList.toggle("dn");
            });
          } else if (e.srcElement.classList.contains('ion-arrow-down-b')) {
            e.srcElement.classList.remove('ion-arrow-down-b');
            e.srcElement.classList.add('ion-arrow-right-b');
            e.srcElement.parentElement.parentElement.childNodes.forEach(element => {
              if(element && element.classList) element.classList.toggle("dn");
            });
          }
        } else if (e.srcElement.children.length > 0 && e.srcElement.children[0].classList.contains('ion-arrow-right-b')) {
          e.srcElement.children[0].classList.remove('ion-arrow-right-b');
          e.srcElement.children[0].classList.add('ion-arrow-down-b');
          this.childNodes.forEach(element => {
            if(element && element.classList) element.classList.toggle("dn");
          });
        } else if (e.srcElement.children.length > 0 && e.srcElement.children[0].classList.contains('ion-arrow-down-b')) {
          e.srcElement.children[0].classList.remove('ion-arrow-down-b');
          e.srcElement.children[0].classList.add('ion-arrow-right-b');
          this.childNodes.forEach(element => {
            if(element && element.classList) element.classList.toggle("dn");
          });
        } else if (e.srcElement.nodeName === 'DIV' && e.srcElement.textContent === dataset.name) {
          this.childNodes.forEach(element => {
            element.childNodes.forEach(e => {
              if (e.classList.contains('ion-arrow-right-b')) {
                e.classList.remove('ion-arrow-right-b');
                e.classList.add('ion-arrow-down-b');
              } else if (e.classList.contains('ion-arrow-down-b')) {
                e.classList.remove('ion-arrow-down-b');
                e.classList.add('ion-arrow-right-b');
              }
            })
            if(element && element.classList) element.classList.toggle("dn");
          });
        }
      }
    }, [
      m('div.flex.items-center', [
        m('i', { class: `ion-arrow-right-b blue f4 w1` }),
        m('div.ml3', [
          m('div.truncate', `${_.startCase(dataset.name)}`) 
        ]),
      ]),
      dataset.type === 'spacer' || dataset.type === 'img' || dataset.type === 'text' ?
        ''
      :
        m('ul.pl4.dn', [
          (dataset.columns || []).map((column, jdx) => {
          return m('div.flex.items-start', [
            m('li.ba.pa2.bw1.flex-auto', {
              style: { 'list-style': 'none' },
              class: 'mv2',
              onclick: function (e) {
                e.stopPropagation();
                if (e.srcElement.nodeName === 'I') {
                  if (e.srcElement.classList.contains('ion-arrow-right-b')) {
                    e.srcElement.classList.remove('ion-arrow-right-b');
                    e.srcElement.classList.add('ion-arrow-down-b');
                    e.srcElement.parentElement.parentElement.childNodes.forEach(element => {
                      element.classList.toggle("dn");
                    });
                  } else if (e.srcElement.classList.contains('ion-arrow-down-b')) {
                    e.srcElement.classList.remove('ion-arrow-down-b');
                    e.srcElement.classList.add('ion-arrow-right-b');
                    e.srcElement.parentElement.parentElement.childNodes.forEach(element => {
                      element.classList.toggle("dn");
                    });
                  }
                } else if (e.srcElement.children.length > 0 && e.srcElement.children[0].classList.contains('ion-arrow-right-b')) {
                  e.srcElement.children[0].classList.remove('ion-arrow-right-b');
                  e.srcElement.children[0].classList.add('ion-arrow-down-b');
                  this.childNodes.forEach(element => {
                    element.classList.toggle("dn");
                  });
                } else if (e.srcElement.children.length > 0 && e.srcElement.children[0].classList.contains('ion-arrow-down-b')) {
                  e.srcElement.children[0].classList.remove('ion-arrow-down-b');
                  e.srcElement.children[0].classList.add('ion-arrow-right-b');
                  this.childNodes.forEach(element => {
                    element.classList.toggle("dn");
                  });
                }
              }
            }, [
                  m('div.flex.items-center', [
                    column.name ?
                      m('div', [
                        m('div.truncate', column.name),
                        buildColumnMetadataText(column)
                          ? m('div.f7.moon-gray.mt1.truncate', buildColumnMetadataText(column))
                          : ''
                      ])
                    :
                      m('div', {style: { 'visibility': 'hidden'}}, 'Placeholder')
                  ])
            ]),
            m(`div.pv2.ml2.w4.w5-m${column.definedBy ? '' : '.flex'}`, [
              column.definedBy ? 
                  m('div.truncate.ba.bw1.pa2',[
                    m(m.route.Link, { 
                      href: `/ontology/${column.definedBy}`, 
                      class: 'pl1'
                    }, column.definedBy)
                  ])
                :
                  [
                    m(buttonElement, {
                      class: 'w-50 mr1',
                      label: m('i.f4.ion-ios-compose-outline.blue'),
                      func: function () {
                        editClassColumnModal.editDialogue(column, {
                          availableKinds: ctrl.availableFieldKinds,
                          availableUnits: ctrl.availableUnits,
                          submitCallback: ctrl.submit
                        });
                      }
                    }),
                    m(buttonElement, {
                      class: 'w-50',
                      label: m('i.f4.ion-ios-trash.red'),
                      func: function () {
                        dataset.columns.splice(jdx, 1)
                      }
                    })
                  ]
                

            ])
          ])
        }),
        m('div.flex.mv2', [
          dataset && dataset.type !== 'gauge' || (dataset.type === 'gauge' && dataset.columns.length == 0) ?
            m('div.flex.flex-auto', [
              m(buttonElement, {
              class: 'flex-auto blue truncate',
              label: [
                m('i.ion-plus.blue.mh1'),
                'Add Column'
              ],
              func: function () {
                if (!dataset.columns) {
                  dataset.columns = [];
                }
                let newColumnRecord = {
                  name: '',
                  kind: '',
                  defaultUnit: '',
                  id: dataset.columns.length == 0 ? 1 : Number(dataset.columns[dataset.columns.length - 1].id) + 1
                };

                let submitCallback = async function (newColumnRecord) {
                  dataset.columns.push(newColumnRecord);
                  await ctrl.submit();
                }

                editClassColumnModal.editDialogue(newColumnRecord, {
                  availableKinds: ctrl.availableFieldKinds,
                  availableUnits: ctrl.availableUnits,
                  submitCallback: submitCallback
                })
              }
              }),
              m('div.pv2-m.ml2-m.ml2-l.w-0.w5-m')
            ])
          :''
        ])
      ]),
    ]),
    m(`div.pv2.ml2.w-third.w4-ns.w5-l${dataset.definedBy ? '' : '.flex'}`, [
      dataset.definedBy ? 
        m('div.truncate.ba.bw1.pa2',[
          m(m.route.Link, { 
            href: `/ontology/${dataset.definedBy}`, 
            class: 'pl2'
          }, dataset.definedBy)
        ])
      :
        [
          m(buttonElement, {
            class: 'w-50 mr1',
            label: m('i.f4.ion-ios-compose-outline.blue'),
            func: editClassDatasetModal.editDialogue.bind(editClassDatasetModal, dataset, {submitCallback: ctrl.submit})
          }),
          m(buttonElement, {
            class: 'w-50',
            label: m('i.f4.ion-ios-trash.red'),
            func: function () {
              datasetDarray.splice(idx, 1)
            }
          })
        ]
    ])
  ])
}

function arePortNamesUnique(data, errors) {

  let names = new Set(); // Set to store unique names
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      const name = data[key].name;
      let errorMessage = `Port names must be unique. ${name} is repeated.`;
      if (names.has(name) && errors.indexOf(errorMessage) == -1) {
        errors.push(`Port names must be unique. ${name} is repeated.`);
      }
      names.add(name);
    }
  }
  return errors.length === 0;
}

function convertToFormData(obj) {
  const formData = new FormData();

  function appendFormData(data, rootKey = '') {
    if (data && typeof data === 'object' && !(data instanceof File)) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          if (rootKey !== '') {
            // For nested objects and arrays, convert them to a JSON string
            appendFormData(data[key], rootKey + '[' + key + ']');
          } else {
            appendFormData(data[key], key);
          }
        }
      }
    } else {
      formData.append(rootKey, data);
    }
  }

  appendFormData(obj);
  return formData;
}

function addOptions(childrenArray, options, level) {
  level++;
  childrenArray.map(category => {
    options.push(m('option', { value: category.name }, `${'-'.repeat(level)} ${category.name}`));
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  })
}

function findFirstServiceClass(categories) {
  for (let idx = 0; idx < (categories || []).length; idx++) {
    let category = categories[idx];
    if (!category) continue;
    if (category.name && category.name !== 'Overview') return category.name;
    let childClass = findFirstServiceClass(category.children || []);
    if (childClass) return childClass;
  }
  return '';
}

function getDefaultServiceClass() {
  return findFirstServiceClass((serviceModel.measurableClassTree || {}).categories || []);
}

function addValidationErrors(errors, newErrors) {
  (newErrors || []).forEach(function (message) {
    if (errors.indexOf(message) === -1) errors.push(message);
  });
}

function validateEmptyProperties(equipmentClass, errors) {
  // Check for empty strings in data.fields
  if (equipmentClass.data && Array.isArray(equipmentClass.data.fields)) {
    normalizeEditableFieldRecords(equipmentClass.data.fields).forEach((field, index) => {
      let fieldName = trimString(field.name);
      let errorMessage = "Fields can't be empty."
      if (!fieldName && errors.indexOf(errorMessage) == -1) {
        errors.push(errorMessage);
      }
      let lengthError = ontologyFields.getFieldNameLengthError(fieldName);
      if (lengthError && errors.indexOf(lengthError) == -1) {
        errors.push(lengthError);
      }
    });
  }
  // Check for empty names in data.datasets
  if (equipmentClass.data && Array.isArray(equipmentClass.data.datasets)) {
    equipmentClass.data.datasets.forEach((group) => {
      let errorMessage = "Datasets can't be empty."
      if (!group.name && errors.indexOf(errorMessage) == -1) {
        errors.push(errorMessage);
      }

      // Check for empty column names in each group
      if (Array.isArray(group.columns)) {
        group.columns.forEach((column) => {
          let errorMessage = `Columns empty on ${group.name} dataset. Columns can't be empty.`
          if (!column.name && errors.indexOf(errorMessage) == -1) {
            errors.push(errorMessage);
          }
        });
      }
    });
  }

  // Check for empty names in data.ports
  if (equipmentClass.data && Array.isArray(equipmentClass.data.ports)) {
    equipmentClass.data.ports.forEach((port, portIndex) => {
      let errorMessage = "Ports can't be empty."
      if (!port.name && errors.indexOf(errorMessage) == -1) {
        errors.push(errorMessage);
      }
    });
  }

  // Check templates
  if (equipmentClass.data && Array.isArray(equipmentClass.data.templates)) {
    let templateNames = new Set();
    let templateRids = new Set();
    equipmentClass.data.templates.forEach((template) => {
      const templateName = template && typeof template.name === 'string' ? template.name.trim() : '';
      const rawTemplateEquipmentRid = template && typeof template.equipmentRid === 'string' ? template.equipmentRid.trim() : '';
      const templateEquipmentRid = normalizeTemplateEquipmentRid(rawTemplateEquipmentRid);

      let nameErrorMessage = "Template names can't be empty.";
      if (!templateName && errors.indexOf(nameErrorMessage) == -1) {
        errors.push(nameErrorMessage);
      }

      let equipmentErrorMessage = "Template equipment @rid can't be empty.";
      if (!rawTemplateEquipmentRid && errors.indexOf(equipmentErrorMessage) == -1) {
        errors.push(equipmentErrorMessage);
      }

      if (templateName) {
        let loweredName = templateName.toLowerCase();
        let duplicateNameErrorMessage = `Template names must be unique. ${templateName} is repeated.`;
        if (templateNames.has(loweredName) && errors.indexOf(duplicateNameErrorMessage) == -1) {
          errors.push(duplicateNameErrorMessage);
        }
        templateNames.add(loweredName);
      }

      if (rawTemplateEquipmentRid && !/^#?\d+:\d+$/.test(rawTemplateEquipmentRid)) {
        let templateRidErrorMessage = `Template equipment @rid is invalid. Use format #<cluster>:<position>. (${rawTemplateEquipmentRid})`;
        if (errors.indexOf(templateRidErrorMessage) == -1) {
          errors.push(templateRidErrorMessage);
        }
        return;
      }

      if (templateEquipmentRid) {
        let duplicateTemplateRidErrorMessage = `Template equipment @rid must be unique. ${templateEquipmentRid} is repeated.`;
        if (templateRids.has(templateEquipmentRid) && errors.indexOf(duplicateTemplateRidErrorMessage) == -1) {
          errors.push(duplicateTemplateRidErrorMessage);
        }
        templateRids.add(templateEquipmentRid);
      }
    });
  }

  return errors.length === 0;

}

function normalizeTemplateEquipmentRid(rid) {
  const trimmedRid = typeof rid === 'string' ? rid.trim() : '';
  if (!trimmedRid) return '';
  return trimmedRid.startsWith('#') ? trimmedRid : `#${trimmedRid}`;
}

function normalizeTemplates(templates) {
  if (!Array.isArray(templates)) return [];
  return templates.map(template => {
    const normalizedTemplate =
      template && typeof template === 'object'
        ? template
        : { name: typeof template === 'string' ? template : '' };
    const name = typeof normalizedTemplate.name === 'string' ? normalizedTemplate.name.trim() : '';
    let equipmentRid = normalizeTemplateEquipmentRid(normalizedTemplate.equipmentRid);
    const path = typeof normalizedTemplate.path === 'string' ? normalizedTemplate.path.trim() : '';
    return {
      name,
      equipmentRid,
      path
    };
  });
}

function sleep(delayMs) {
  return new Promise(resolve => setTimeout(resolve, delayMs));
}

async function ensureClassAvailable(className) {
  const attempts = 6;
  const delayMs = 250;
  const countUrl = `/api/v1/ontology/class/${encodeURIComponent(className)}/count?type=equipment`;

  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      await loaders.requestWithLoader({
        loader: 'background',
        url: countUrl,
        method: 'GET',
        background: true
      });
      return;
    } catch (error) {
      if (error && error.error === 'Class not found' && attempt < attempts) {
        await sleep(delayMs * attempt);
        continue;
      }
      throw error;
    }
  }
}



module.exports = ontologyDetail;
